// Identify user in Appcues
export function identifyAppcues(user, workspaceId, userIdentity, groupIdentity) {
    if (!window.Appcues) return;
    window.Appcues.identify(user.uid, userIdentity);
    window.Appcues.group(workspaceId, groupIdentity);
}

// Track an event in Appcues
export function trackAppcues(eventId, event, user) {
    if (!user || !user.uid || !window.Appcues) return;
    window.Appcues.track(eventId, event);
}
